const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKarate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "60px",
    height: "60px",
    viewBox: "0 0 340 340",
    id: "icons",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M80.292,266.734s-26.357,31.213-38.944,49.125a25.453,25.453,0,0,0-3.973,8.691,17.13,17.13,0,0,0-.523,5.558l64.829-.27,35.241-51.747s45.238,23.626,69.143,52.017H258.7s0-.2,0-.567A29.56,29.56,0,0,0,250.092,309L197.5,255.938l-97.418-1.8Z",
    style: {
      fill: "#e9ebfc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.313,284.35l21.843-12.619L197.5,255.938l-97.418-1.8L80.292,266.734s-4.14,4.9-9.915,11.929c5.463,3.212,11.3,6.895,17.01,10.641a20.071,20.071,0,0,1,8.18,22.746L89.95,330.108h13.219l17.585-26.184h0L137.021,279.7s28.594,17.111,28.752,17.218c13,8.788,27.847,20.332,38.671,33.187h13.722c-5.148-11.823-17.834-24.111-28.022-32.649A8.037,8.037,0,0,1,191.313,284.35Z",
    style: {
      fill: "#acb9d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.624,118.222l.867-4.45a17.243,17.243,0,0,1,6.605-10.515l7.066-4.772a4.546,4.546,0,0,1,7.09,3.827l-.021,1.611,11.776-6.833a5.608,5.608,0,0,1,8.276,4.548l.9,13.236a11.557,11.557,0,0,1-4.874,10.228L258.7,153.017Z",
    style: {
      fill: "#ffc4b6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "267.087 147.104 260.624 118.222 258.697 153.017 267.087 147.104",
    style: {
      fill: "#ea8b7f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.412,112.544l18.347,8.664,48.6,25.637,41.266-28.623,2.095,64.541A115.165,115.165,0,0,1,230.6,189.32a35.9,35.9,0,0,1-20.669-4.61l-29.394-14.6-11.158,45.951a408.932,408.932,0,0,1,36.014,38.071,6.146,6.146,0,0,1-2.131,9.493L146.913,289.9l-15.022-25.982-15.546,29.345a273.66,273.66,0,0,0-38-23.036,7.389,7.389,0,0,1-2.507-11.268l28.93-36-3.411-110.113,37.8-5.67Z",
    style: {
      fill: "#e9ebfc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.763,222.958,85.886,246.449a145.277,145.277,0,0,0,69.148,16.4,5.066,5.066,0,0,0,4.938-5.071V245.39s19.822,1.114,37.3-.711c-8.583-9.688-16.355-17.55-21.5-22.565l-71.29-9.287Z",
    style: {
      fill: "#acb9d4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.973 107.092 138.354 106.066 101.673 111.692 102.201 130.717 136.725 118.222 140.973 107.092",
    style: {
      fill: "#acb9d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.816,265.2a515.351,515.351,0,0,1,14.429,51.36,7.345,7.345,0,0,0,4.045,5.081l12.014,5.692a3.173,3.173,0,0,0,4.458-3.564c-3.642-16.08-13.915-58.472-24.775-76.51Z",
    style: {
      fill: "#363b42"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.209,244.145a713.027,713.027,0,0,0-16.321,80.68,3.217,3.217,0,0,0,4.276,3.474l12.445-4.508a7.386,7.386,0,0,0,4.763-5.722,496.352,496.352,0,0,1,16.774-68.785Z",
    style: {
      fill: "#363b42"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.119,107.932l-4.765-1.866L114.3,109.755c2.147,13.13,10.359,46.673,26.684,60.353l9.639-21.573Z",
    style: {
      fill: "#acb9d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.73,215.481l14.277-2.01,5.617-23.13c-8.569-1.75-22.993,5.61-22.993,5.61-14.11-1.758-30.811-7.294-37.477-9.644a5.552,5.552,0,0,1-3.59-4.123l-7.8-37.9s-.429,1.326-1.094,3.432l1.39,50.019,14.272,10.836Z",
    style: {
      fill: "#acb9d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.354,106.066,114.3,109.755c.615,3.759,1.73,9.2,3.387,15.356l19.035-6.889,4.248-11.13Z",
    style: {
      fill: "#acb9d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.558,126.535l-3.439-18.6-4.765-1.866L114.3,109.755c.615,3.759,1.73,9.2,3.387,15.356l15.119-5.472,11.6,9.094Z",
    style: {
      fill: "#78839e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.5,110.04l-4.886,39.97a329.014,329.014,0,0,1-30.08,49.655l15.04,7.472s26.518-39.55,38.582-72.909a88.666,88.666,0,0,0,3.6-13.02l-18.038-9.516Z",
    style: {
      fill: "#acb9d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.1,86.433l-2.174,22.823s-1.358,15.215,11.683,40.754A100.246,100.246,0,0,0,152.2,133.6a64.813,64.813,0,0,0,4.723-24.595V95.4Z",
    style: {
      fill: "#ffc4b6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.927,203.691a58.425,58.425,0,0,1,11.347-5.169,6.835,6.835,0,0,1,8.147,3.357l1.97,3.78,12.878.989a9.5,9.5,0,0,1,8.723,10.475l-1.217,11.517a9.935,9.935,0,0,1-10.39,8.883c-7.971-.413-19.7-1.17-29.916-2.417l-8.861-2.483Z",
    style: {
      fill: "#ffc4b6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.093,233.715c2.838.52,6.026.981,9.376,1.39-2.378-19.13-1.542-31.414-1.542-31.414Z",
    style: {
      fill: "#ea8b7f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.258,111.756l-9.992,1.533A18.413,18.413,0,0,0,75.9,128.421C72.755,146.994,67.58,182,67.455,211.906a16.261,16.261,0,0,0,5.63,12.414c10.645,9.162,36.557,27.048,77.541,28.086,0,0-1.45-25.888,6.3-48.715,0,0-34.254-5.415-50.255-14.165l-3.793-59.055Z",
    style: {
      fill: "#e9ebfc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.352,112.845l-9.928,2.077c-7.851,1.2-13.349,5.98-14.676,13.811-.612,3.612-2.86,12.231-2.86,12.231-2.955,19.453-6.333,46.851-6.433,70.942a16.261,16.261,0,0,0,5.63,12.414c10.645,9.162,36.557,27.048,77.541,28.086,0,0-1.45-25.888,6.3-48.715,0,0-34.254-5.415-50.255-14.165l-3.793-59.055Z",
    style: {
      fill: "#e9ebfc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.879,130.471l-1.206-18.779-10.407,1.6A18.413,18.413,0,0,0,75.9,128.421c-.611,3.611-1.3,7.848-2.013,12.543Z",
    style: {
      fill: "#acb9d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.927,109.006V95.4L134.1,86.433l-2.174,22.823a43.934,43.934,0,0,0,.878,10.383l24.075-8.713C156.9,110.286,156.927,109.647,156.927,109.006Z",
    style: {
      fill: "#ea8b7f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.411,16.086s25.062-2.685,32.819,23.57c0,0,10.74,32.222-14.619,32.818l-45.846,6.79a24.351,24.351,0,0,1-25.423-12.971,36.852,36.852,0,0,1-3.319-10.825s-4.011-26.327,19.456-40.6a33.768,33.768,0,0,1,14.7-4.819C145.69,9.51,155.008,10.063,161.411,16.086Z",
    style: {
      fill: "#383a3d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.9,29.187s-2.223,29.532-27.31,36.2a23.207,23.207,0,0,0-2.066-4.33,5.985,5.985,0,0,0-10.4.522c-1.387,2.83-2.535,7.145-2.455,13.652,0,0-.317,6.669,7.622,7.939l.747,5.42a10.5,10.5,0,0,0,4.246,7.1c4.388,3.163,13.161,7.8,28.908,10.253a10.255,10.255,0,0,0,11.4-7.184C182.713,81.64,191.151,42.659,166.9,29.187Z",
    style: {
      fill: "#ffc4b6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.21,68.579a2.993,2.993,0,0,1-1.5-.4l-2.482-1.433a3,3,0,1,1,3-5.2l2.482,1.432a3,3,0,0,1-1.5,5.6Z",
    style: {
      fill: "#ea8b7f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.727,72.153h-2.569a3,3,0,0,1,0-6h2.569a3,3,0,0,1,0,6Z",
    style: {
      fill: "#ea8b7f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.175,89.2a2.983,2.983,0,0,1-1.257-.278,20.264,20.264,0,0,0-5.067-1.482,3,3,0,0,1,.784-5.949,26.3,26.3,0,0,1,6.8,1.985,3,3,0,0,1-1.262,5.724Z",
    style: {
      fill: "#ea8b7f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.181,115.571c0-.233.014-.463,0-.7l-.33-4.879-19.766,10.7c-.137-1.543-.28-3.247-.413-4.969l19.815-11.113-.2-2.973a5.562,5.562,0,0,0-.708-2.364l-19.254,11.313a49.747,49.747,0,0,1-.09-6.664l-6.707,4.816a3.767,3.767,0,0,0-1.538,3.219c.081,2.237-.515,6.07-4.642,9.514a2.656,2.656,0,0,0-1.038,1.9,2.522,2.522,0,0,0,4.161,2.046,15.117,15.117,0,0,0,4.858-7.839.256.256,0,0,1,.5.037l.734,9.93a2.492,2.492,0,0,0,3.893,1.874l.15-.1a2.492,2.492,0,0,0,1.074-2.288s-.05-.495-.132-1.335Z",
    style: {
      fill: "#ea8b7f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.924,218.881l16.739,1.357.329-3.115a9.545,9.545,0,0,0,.021-1.663l-16.7-1.353a2.394,2.394,0,0,0-2.58,2.194h0A2.394,2.394,0,0,0,182.924,218.881Z",
    style: {
      fill: "#ea8b7f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.724,226.425h0a2.4,2.4,0,0,0,2.194,2.581l16.42,1.33a10.024,10.024,0,0,0,.337-1.7l.323-3.056-16.693-1.352A2.4,2.4,0,0,0,179.724,226.425Z",
    style: {
      fill: "#ea8b7f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.358,171.615c-10.618,7.458-24.553,10.827-32.687,12.236a19.344,19.344,0,0,1-12.143-1.876l-26.039-13.39a5.1,5.1,0,0,1-2.679-3.6l-1.479-8.01a1.541,1.541,0,0,0-3-.144l-3.8,13.281,28.743,16.1a39.007,39.007,0,0,0,21.535,4.929,104.054,104.054,0,0,0,31.949-7Z",
    style: {
      fill: "#acb9d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.82,151.364a1.831,1.831,0,0,0,2.684,2.316l9.854-6.835-8.165-4.307Z",
    style: {
      fill: "#acb9d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.506,75.373c.693-2.543,1.379-6.751-.146-10.538a3.359,3.359,0,0,0-3.945-2.011l-.058.017a6.327,6.327,0,0,0-.961.37.454.454,0,0,0,.153.86c1.406.147,3.45.919,3.472,4.162a.874.874,0,0,1-1.089.86,2.6,2.6,0,0,0-3.073,1.18,4.011,4.011,0,0,0-.444,3.129,8.149,8.149,0,0,0,1.348,2.934A2.707,2.707,0,0,0,134.506,75.373Z",
    style: {
      fill: "#ea8b7f"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKarate);
export default __webpack_public_path__ + "static/media/karate.fe04b595a1842315df3395ff0df1d338.svg";
export { ForwardRef as ReactComponent };